<script>
	import { onMount, onDestroy } from 'svelte'
	import { getContext } from 'svelte'
	import { v4 as uuidv4 } from 'uuid'
	import { styles } from '../../../library/scripts/styles.js'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import { storeUploader, storeShowItem } from '../../../library/scripts/Store.svelte'
	import { upload_image } from '../../../library/scripts/fileUploader'
	import { get_username } from '../../../library/scripts/utils'
	import { getCookie } from '../../../library/scripts/cookie'
	import { adminUpdateShopEntry, SingleItem, check_values } from '../AdminModule.svelte'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Alert from '../../../modals/Alert.svelte'
	const globals = getContext('globals')

	//the upload action
	let upload
	const stoUploader = storeUploader.subscribe((value) => {
		upload = value
	})

	const shadow = globals.boxShadow
	const fontX = globals.fsL
	const fontM = globals.fsN
	const fontS = globals.fsS
	const color = globals.colorMain
	const inputFocus = globals.bgLight
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover

	const userID = getCookie('id')

	//variable to show or hide category input according to selected radio button
	let categoryInputVisible = true

	//the new element to add
	let addElement = {}

	//values for item entries
	let itemId = ''
	let itemCategory = ''
	let itemName = ''
	let shortDescription = ''
	let longDescription = ''
	let itemImage = ''
	let itemPrice = ''
	let stock = 1
	let itemProperties = ''
	let itemCurrency = 'CHF'

	//update item
	let oldImage = ''

	//store the items
	let items = []

	let categories = []

	//success and error message
	let error = false
	let success = false

	//message to the user
	let message = ''

	//alert window
	let alertError = false

	//create single item entries if item is changed by user
	let singleItem = false
	const stoSingleItem = SingleItem.subscribe((value) => {
		singleItem = value
	})

	$: if (singleItem) {
		const amendItem = singleItem.split('~')
		itemId = amendItem[0]
		itemCategory = amendItem[1]
		itemName = amendItem[2]
		itemProperties = amendItem[3]
		shortDescription = amendItem[4]
		longDescription = amendItem[5]
		itemImage = amendItem[6]
		itemPrice = amendItem[7]
		stock = amendItem[8]
		itemCurrency = amendItem[9]
	}

	//create the entry and check for errors
	function check_item(c) {
		let check = false
		let id = null

		//create the id (if its an update we have to get it from storage)
		if (!c) id = uuidv4()
		else {
			const storeItems = JSON.parse(sessionStorage.getItem('shop'))
			storeItems.forEach((item) => {
				for (const key in item) {
					if (item['name'] === itemName) {
						id = item['id']
					}
				}
			})
		}
		//new item
		if (!c) {
			//check if its a dupilcate
			let duplicate = false

			const sessItems = JSON.parse(sessionStorage.getItem('shop'))

			//check if item already exists
			sessItems.forEach((item) => {
				for (const key in item) {
					if (item['name'] === itemName) {
						error = true
						message = 'duplicate item'
						duplicate = true
						set_error()
					}
				}
			})

			//if the item exists we return with no action
			if (duplicate) return
		}

		//create the element to add
		addElement = {
			id: id,
			category: itemCategory,
			name: itemName,
			descshort: shortDescription,
			desclong: longDescription,
			image: itemImage,
			price: itemPrice,
			stock: stock,
			properties: itemProperties,
			currency: itemCurrency,
		}

		//evaluate entries
		check = check_values('shop', addElement)

		//if all is well we add the item to the storage
		if (check === true) {
			if (!c) save_item(addElement)
			if (c) update_item(addElement)
			return
		}

		error = true
		message = check
		set_error()
	}

	//add element and handle views of the DOM
	const save_item = async (item) => {
		//shader
		storeUploader.set(true)

		//create the item to save in session store
		let storeItem = { ...item }

		//get session storage
		let sessItems = JSON.parse(sessionStorage.getItem('shop'))

		//get the name of the image
		const image = item.image.files[0].name
		storeItem.image = image

		//save the item to the db
		const saveItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'save_shop_entry',
				data: storeItem,
			}),
		})

		const dataResponse = await saveItem.json()

		//if the item is added to the DB sucessfully we continue saving
		if (dataResponse) {
			//first we check if the image is already used by another item
			let usedImage = false

			sessItems.forEach((item) => {
				for (const key in item) {
					if (item['image'] === image) usedImage = true
				}
			})

			//close the shader if no image is attached
			if (usedImage) storeUploader.set(false)

			//save the image
			if (!usedImage) {
				const uploadImage = upload_image('shop', item.image, item.name)
				//shader is handled by function
			}
		}

		//safe the item to the session storage
		sessItems = [...sessItems, storeItem]
		sessionStorage.setItem('shop', JSON.stringify(sessItems))

		//update page
		adminUpdateShopEntry.set(JSON.stringify(sessItems))

		//reset currency variable
		itemCurrency = 'CHF'
	}

	const update_item = async (item) => {
		//the shader
		storeUploader.set(true)
		//get the old image from session store

		//item copy to replace image-object with image-name for storing
		let itemStorage = { ...item }
		itemStorage.image = item.image.files[0].name

		const sessStore = JSON.parse(sessionStorage.getItem('shop'))
		sessStore.forEach((prod) => {
			if (prod.id === itemStorage.id) itemStorage.oldimage = prod.image
		})

		//update the db
		const updateItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'update_shop_entry',
				data: itemStorage,
			}),
		})

		const response = await updateItem.json()

		if (response.products) {
			//close the single item
			SingleItem.set(false)
			storeShowItem.set(false)

			//create the product objects
			let updatedProducts = []

			//update store and session-storage
			response.products.forEach((item) => {
				updatedProducts.push({
					id: item[0],
					category: item[1],
					name: item[2],
					properties: item[3],
					descshort: item[4],
					desclong: item[5],
					image: item[6],
					price: item[7],
					stock: item[8],
					currency: item[9],
				})
			})

			/**image handling **/
			let imageCounter = 0
			let uploadImage = true

			//same image added
			if (itemStorage.image === itemStorage.oldimage) uploadImage = false

			if (itemStorage.image !== itemStorage.oldimage) {
				// check if the image is used by another item
				const sessShop = JSON.parse(sessionStorage.getItem('shop'))
				sessShop.forEach((item) => {
					for (let key in item) {
						if (key === 'image') {
							if (item.name !== itemStorage.name && item.image === itemStorage.image) {
								uploadImage = false
							}
						}
					}
				})

				if (uploadImage) {
					upload_image('shop', item.image, item.name)
					//close shader is handled by function upload_image
				}
			}
			if (!uploadImage) storeUploader.set(false)
			sessionStorage.setItem('shop', JSON.stringify(updatedProducts))
			adminUpdateShopEntry.set(JSON.stringify(updatedProducts))

			itemCurrency = 'CHF'
		}
	}

	//select if category input or select is visible (radio button selection)
	const selectCategoryInput = () => {
		categoryInputVisible = categoryInputVisible === true ? false : true
	}

	const set_error = () => {
		const toError = setTimeout(() => {
			error = false
			message = ''
			clearTimeout(toError)
		}, 2000)
	}

	const close_update = () => {
		itemCategory = ''
		itemName = ''
		shortDescription = ''
		longDescription = ''
		itemPrice = ''
		stock = 1
		itemProperties = ''
		itemCurrency = 'CHF'
		SingleItem.set(false)
		storeShowItem.set(false)
	}

	//reset error messages
	const reset_error = (c) => {
		error = false
		success = false
		alertError = false
	}

	onMount(async () => {
		const getCategory = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'get_shop_categories',
			}),
		})

		const dataResponse = await getCategory.json()
		categories = dataResponse.fetch

		if (dataResponse.fetch != 0) {
			categoryInputVisible = false
			itemExist = true
		}
	})

	onDestroy(() => {
		stoSingleItem
		stoUploader
		sessionStorage.clear('shopimg')
	})
</script>

<div class="container">
	{#if upload}
		<Shader>
			<div slot="content">
				<Spinner color="hsl(0,0%,60%)" size="4vw" info="content uploading" fontsize={fontM} />
			</div>
		</Shader>
	{/if}
	{#if !singleItem}
		<div class="title" use:styles={{ color, fontX }}>ADD ITEM</div>
		<form use:styles={{ fontS }}>
			{#if itemExist != null}
				<div class="radio">
					{#if !categoryInputVisible}
						<input
							use:styles={{ fontM, color, shadow }}
							on:change={selectCategoryInput}
							type="radio"
							id="sg"
							name="g"
							checked="checked"
						/>
					{:else}
						<input
							use:styles={{ fontM, color, shadow }}
							on:change={selectCategoryInput}
							type="radio"
							id="sg"
							name="g"
						/>
					{/if}
					<label use:styles={{ fontM, color }} for="sg">existing category</label>
				</div>

				<div class="radio">
					{#if categoryInputVisible}
						<input
							use:styles={{ fontM, color, shadow }}
							on:change={selectCategoryInput}
							type="radio"
							id="ng"
							name="g"
							checked="checked"
						/>
					{:else}
						<input
							use:styles={{ fontM, color, shadow }}
							on:change={selectCategoryInput}
							type="radio"
							id="ng"
							name="g"
						/>
					{/if}
					<label use:styles={{ fontM, color }} for="ng">new category</label>
				</div>

				{#if !categoryInputVisible}
					<label use:styles={{ fontM, color }} for="selectGroup">category</label>
					<select use:styles={{ shadow, fontM, color }} id="selectGroup" bind:value={itemCategory}>
						<option value="" selected>--</option>
						{#if categories.length > 0}
							{#each categories as category}
								<option value={category}>{category}</option>
							{/each}
						{/if}
					</select>
				{/if}
			{/if}

			{#if !itemExist || categoryInputVisible}
				<label use:styles={{ fontM, color }} for="category">category</label>
				<input
					use:styles={{ fontM, color, shadow, inputFocus }}
					on:focus={reset_error}
					type="text"
					id="category"
					maxlength="32"
					bind:value={itemCategory}
				/>
			{/if}
			<label use:styles={{ fontM, color }} for="item">name</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="item"
				maxlength="25"
				placeholder="item name"
				bind:value={itemName}
			/>

			<label use:styles={{ fontM, color }} for="item">properties</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="item"
				maxlength="25"
				placeholder="item properties"
				bind:value={itemProperties}
			/>
			<div class="sub_title" use:styles={{ fontM, color }}>descriptions</div>
			<div />
			<label use:styles={{ fontM, color }} for="item">short</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="longDescription"
				maxlength="150"
				placeholder="short description"
				bind:value={shortDescription}
			/>
			<label use:styles={{ fontM, color }} for="description">long</label>
			<textarea
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="shortDescription"
				placeholder="long description"
				bind:value={longDescription}
			/>

			<div class="sub_title" use:styles={{ fontM, color }}>descriptions</div>
			<div />

			<label use:styles={{ fontM, color }} for="image">image</label>
			<input
				use:styles={{ fontM, color, shadow }}
				on:focus={reset_error}
				type="file"
				id="image"
				accept="image/*"
				bind:this={itemImage}
			/>

			<label use:styles={{ fontM, color }} for="size">price</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="size"
				maxlength="6"
				placeholder="price"
				bind:value={itemPrice}
			/>
			<label use:styles={{ fontM, color }} for="price">stock</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="price"
				maxlength="6"
				placeholder="stock"
				bind:value={stock}
			/>
			<label use:styles={{ fontM, color }} for="currency">currency</label>
			<select use:styles={{ shadow, fontM, color }} id="currency" bind:value={itemCurrency}>
				<option value="CHF">CHF</option>
				<option value="EU">EU</option>
				<option value="USD">USD</option>
				<option value="ZAR">ZAR </option>
				<option value="YEN">YEN</option>
			</select>

			<button use:styles={{ fontS, shadow, buttonColor, buttonHover }} on:click|preventDefault={() => check_item(false)}
				>save</button
			>

			<!-- error and other messages -->
			{#if error}
				<div class="message error">{message}</div>
			{/if}
			{#if success}
				<div class="message success">{message}</div>
			{/if}
		</form>
	{:else}
		<div class="title" use:styles={{ color, fontX }}>AMEND ITEM</div>
		<form use:styles={{ fontS }}>
			<label use:styles={{ fontM, color }} for="selectGroup">category</label>
			<select use:styles={{ shadow, fontM, color }} id="selectGroup" bind:value={itemCategory}>
				<option value="" selected>--</option>
				{#if categories.length > 0}
					{#each categories as category}
						<option value={category}>{category}</option>
					{/each}
				{/if}
			</select>

			{#if !itemExist || categoryInputVisible}
				<label use:styles={{ fontM, color }} for="category">category</label>
				<input
					use:styles={{ fontM, color, shadow, inputFocus }}
					on:focus={reset_error}
					type="text"
					id="category"
					maxlength="32"
					bind:value={itemCategory}
				/>
			{/if}
			<label use:styles={{ fontM, color }} for="item">name</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="item"
				maxlength="25"
				placeholder="item name"
				bind:value={itemName}
			/>

			<label use:styles={{ fontM, color }} for="item">properties</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="item"
				maxlength="25"
				placeholder="item properties"
				bind:value={itemProperties}
			/>
			<div class="sub_title" use:styles={{ fontM, color }}>descriptions</div>
			<div />
			<label use:styles={{ fontM, color }} for="item">short</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="longDescription"
				maxlength="150"
				placeholder="short description"
				bind:value={shortDescription}
			/>
			<label use:styles={{ fontM, color }} for="description">long</label>
			<textarea
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="shortDescription"
				placeholder="long description"
				bind:value={longDescription}
			/>

			<div class="sub_title" use:styles={{ fontM, color }}>descriptions</div>
			<div />

			<label use:styles={{ fontM, color }} for="image">image</label>
			<input
				use:styles={{ fontM, color, shadow }}
				on:focus={reset_error}
				type="file"
				id="image"
				accept="image/*"
				bind:this={itemImage}
			/>

			<label use:styles={{ fontM, color }} for="size">price</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="size"
				maxlength="6"
				placeholder="price"
				bind:value={itemPrice}
			/>
			<label use:styles={{ fontM, color }} for="price">stock</label>
			<input
				use:styles={{ fontM, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="price"
				maxlength="6"
				placeholder="stock"
				bind:value={stock}
			/>
			<label use:styles={{ fontM, color }} for="currency">currency</label>
			<select use:styles={{ shadow, fontM, color }} id="currency" bind:value={itemCurrency}>
				<option value="CHF">CHF</option>
				<option value="EU">EU</option>
				<option value="USD">USD</option>
				<option value="ZAR">ZAR </option>
				<option value="YEN">YEN</option>
			</select>

			<div class="button_container">
				<button use:styles={{ fontS, shadow, buttonColor, buttonHover }} on:click|preventDefault={close_update}
					>close</button
				>
				<button
					use:styles={{ fontS, shadow, buttonColor, buttonHover }}
					on:click|preventDefault={() => check_item(true)}>save</button
				>
			</div>
			<!-- error and other messages -->
			{#if error}
				<div class="message error">{message}</div>
			{/if}
			{#if success}
				<div class="message success">{message}</div>
			{/if}
		</form>
	{/if}
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		width: 100%;
		cursor: default;
		user-select: none;
	}

	.title {
		font-size: var(--fontX);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 20px;
	}

	.sub_title {
		font-size: var(--fontM);
		color: var(--color);
		text-decoration: underline;
		margin-top: 25px;
	}

	form {
		display: grid;
		grid-template-columns: 30% 70%;
		width: 85%;
		margin-left: 3%;
		font-size: var(--fontS);
	}

	label {
		display: flex;
		align-items: flex-start;
		font-size: var(--fontM);
		color: var(--color);
	}

	input[type='radio'] {
		margin: 0;
		padding: 0;
		outline: none;
		width: clamp(12px, 1.27vw, 20px);
		height: clamp(12px, 1.59vw, 20px);
	}

	input[type='text'],
	input[type='file'],
	textarea {
		outline: none;
		box-shadow: 3px 3px 3px var(--shadow);
		font-size: var(--fontM);
		border: 1px solid ghostwhite;
		background-color: transparent;
		color: var(--color);
		width: 100%;
	}

	textarea {
		resize: none;
		margin-bottom: 30px;
	}

	input[type='text']:focus,
	textarea:focus {
		background-color: var(--inputFocus);
	}

	select {
		border: 1px solid ghostwhite;
		background-color: transparent;
		box-shadow: 3px 3px 3px var(--shadow);
		color: var(--color);
	}

	option {
		background-color: black;
		color: white;
	}

	button {
		width: 20%;
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: flex-end;
		margin-right: 2%;
		border-radius: 5px;
		font-size: var(--fontS);
		color: var(--buttonColor);
		box-shadow: 3px 3px 3px var(--shadow);
		background-color: transparent;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.button_container {
		width: 90%;
		display: flex;
		justify-content: flex-end;
		grid-column-start: 1;
		grid-column-end: 3;
	}

	.radio {
		display: grid;
		grid-template-columns: 20% 80%;
		align-items: start;
		margin-bottom: 10%;
	}

	.message {
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: center;
		font-size: clamp(0.8rem, 1.1vw, 1.2rem);
	}

	.success {
		color: green;
	}

	.error {
		color: red;
	}
</style>
